.starch-tickets-app {
  margin: 1em;
}

.starch-tickets-app label {
  font-weight: bold;
}
.starch-tickets-app h3 {
  font-size: 1.75rem;
  border-bottom: 1px solid #cdcdcd;
  line-height: 2;
  margin-bottom: 2rem;
}

.starch-tickets-app .form-control {
  border-left: 5px solid #42a948;
}

.starch-tickets-app .invalid-field {
  border-left: 5px solid #a94442;
}

.starch-tickets-app .btn-primary:disabled {
  cursor: not-allowed;
}

.city-search-results {
  list-style-type: none;
  padding: 0;
  max-height: 228px;
  overflow: auto;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}

.city-search-results li a {
  padding: 10px;
  display: block;
  cursor: pointer;
}

.city-search-results li a:hover {
  background: #ccc;
}
